import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import MonthsDropDown from "../Shared/MonthsDropDown";
import YearsDropDown from "../Shared/YearsDropDown";
import FeeSystemMenu from "./FeeSystemMenu";
import { toast, ToastContainer } from "react-toastify";
import { NavLink } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";

function DeletedVouchers() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [listOfChallans, setListOfChallans] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [SelectedMonth, setSelectedMonth] = useState(moment().format("M"));
  const [SelectedYear, setSelectedYear] = useState(moment().format("YYYY"));
  const [Registration_No, SetRegistrationNo] = useState("");
  const [ChallanNoFilter, setChallanNoFilter] = useState("");
  const [referenceTypeFilter, setReferenceTypeFilter] = useState("");

  useEffect(() => {
    document.title = "Deleted Vouchers";
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNo, pageSize, SelectedMonth, SelectedYear, Registration_No, ChallanNoFilter, referenceTypeFilter]);

  const fetchData = () => {
    setLoading(true);
    const data = {
      AccessKey,
      UserID,
      MemberType,
      pageNo,
      pageSize,
      SelectedMonth,
      FYear: SelectedYear,
      Registration_No,
      ChallanNo: ChallanNoFilter || undefined,
      Reference_ID_Type: referenceTypeFilter || undefined,
    };

    axios({
      method: "post",
      url: config.base_url + "MonthlyTask/GetDeletedChalanHeads",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        setListOfChallans(response.data.ListofRecords || []);
        setTotalRecords(response.data.totalRecords || 0);
      })
      .catch(() => {
        toast.error("Error loading deleted vouchers list.", { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => setLoading(false));
  };

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const handleRestore = (challanNo) => {
    if (!window.confirm(`Are you sure you want to restore challan ${challanNo}?`)) {
      return;
    }

    const data = {
      AccessKey,
      UserID,
      MemberType,
      ChallanNo: challanNo,
    };

    axios({
      method: "post",
      url: config.base_url + "MonthlyTask/RestoreChallan",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
          fetchData();
        } else {
          toast.error(response.data.status_message || "Failed to restore challan.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error("Error restoring challan.", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const renderRows = () => {
    if (listOfChallans.length === 0) {
      return (
        <tr>
          <td colSpan="13">
            <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
              No deleted vouchers found.
            </h4>
          </td>
        </tr>
      );
    }

    return listOfChallans.map((item, index) => (
      <tr key={index}>
        <td>{item.Challan_No}</td>
        <td>{item.Registration_No}</td>
        <td>{item.Student_Name}</td>
        <td>{item.Father_Name}</td>
        <td>{item.Class_Name}</td>
        <td>{item.Section_Name}</td>
        <td>{item.Month}-{item.Year}</td>
        <td>{moment(item.Due_Date).format("DD/MM/YYYY")}</td>
        <td>{item.Due_Date_Amount}</td>
        <td>{item.Is_Paid ? "Paid" : "Unpaid"}</td>
        <td>
          <button
            type="button"
            className="btn btn-success btn-sm border-0"
            onClick={() => handleRestore(String(item.Challan_No || "").trim())}
            // Allow restoring even if paid; backend now permits it
          >
            Restore
          </button>
        </td>
        <td>{item.DeletedBy || ""}</td>
        <td>{item.DeleteReason || ""}</td>
      </tr>
    ));
  };

  return (
    <>
      <FeeSystemMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/Dashboard">Dashboard</NavLink>
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/FeeSystem/FeeSystemDashboard">Fee System</NavLink>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Deleted Vouchers
                  </li>
                </ol>
              </nav>
              <div className="page-title">Deleted Vouchers</div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <p className="text-muted mb-4">
                This page lists <strong>deleted challans/vouchers</strong>. You can restore a voucher if it was deleted by mistake.
                Only <strong>unpaid</strong> challans can be restored.
              </p>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  setPageNo(1);
                  fetchData();
                }}
                className="mb-3"
              >
                <div className="row g-3 align-items-end">
                  <div className="col-md-3">
                    <label className="form-label">Month</label>
                    <select
                      className="form-select"
                      value={SelectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                    >
                      <MonthsDropDown />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Year</label>
                    <select
                      className="form-select"
                      value={SelectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                    >
                      <YearsDropDown />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Registration No</label>
                    <input
                      type="text"
                      className="form-control"
                      value={Registration_No}
                      onChange={(e) => SetRegistrationNo(e.target.value)}
                      placeholder="Registration No"
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Challan / Voucher No</label>
                    <input
                      type="text"
                      className="form-control"
                      value={ChallanNoFilter}
                      onChange={(e) => setChallanNoFilter(e.target.value)}
                      placeholder="Challan No"
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Challan Type</label>
                    <select
                      className="form-select"
                      value={referenceTypeFilter}
                      onChange={(e) => setReferenceTypeFilter(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Installment">Installment</option>
                      <option value="Admission">Admission</option>
                      <option value="Advance">Advance</option>
                    </select>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-3">
                    <button type="submit" className="button button-primary" disabled={loading}>
                      {loading ? <Spinner animation="border" size="sm" className="me-1" /> : null}
                      Load Deleted Vouchers
                    </button>
                  </div>
                </div>
              </form>

              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Challan No</th>
                      <th>Reg No</th>
                      <th>Student</th>
                      <th>Father Name</th>
                      <th>Class</th>
                      <th>Section</th>
                      <th>Month/Year</th>
                      <th>Due Date</th>
                      <th>Amount</th>
                      <th>Paid</th>
                      <th>Action</th>
                      <th>Deleted By</th>
                      <th>Delete Reason</th>
                    </tr>
                  </thead>
                  <tbody>{loading ? (
                    <tr>
                      <td colSpan="13" className="text-center">
                        <Spinner animation="border" size="sm" /> Loading...
                      </td>
                    </tr>
                  ) : (
                    renderRows()
                  )}</tbody>
                </table>
              </div>

              {totalRecords > 0 && (
                <div className="pagination-wrap">
                  <div className="row align-items-center">
                    <div className="col-md-2 form_default">
                      <div className="d-flex align-items-center">
                        <label className="me-2" style={{ fontSize: "15px" }}>
                          Page Size
                        </label>
                        <div className="form-group">
                          <select
                            className="form-select"
                            style={{ width: "100px" }}
                            value={pageSize}
                            onChange={(e) => {
                              setPageNo(1);
                              setPageSize(parseInt(e.target.value, 10));
                            }}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <Pagination
                      currentPage={pageNo}
                      pageSize={pageSize}
                      totalRecords={totalRecords}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeletedVouchers;

